<div class="row">
  <div labelTextInput class="col-xs-12 col-sm-6 bloccodati"
       [typeLabel]="'text'" [labelInput]="'Categoria'"
       [valueInput]="controparte.categoria ? (controparte.categoria?.label) : ''"></div>
  <!--<div labelTextInput class="col-sm-2 bloccodati"
       [typeLabel]="'date'" [labelInput]="'Data associazione'"
       [valueInput]="controparte.dataAssociazione"></div>-->
  <!--<div labelTextInput class="col-sm-2 bloccodati"
       [typeLabel]="'boolean'" [labelInput]="'Cliente'"
       [valueInput]="controparte.cliente"></div>-->
  <div labelTextInput class="col-xs-12 col-sm-4 bloccodati"
       [typeLabel]="'boolean'" [labelInput]="'Rinuciatario'"
       [valueInput]="controparte.ritirato"></div>
  <div labelTextInput style="padding: 0px 5px 0px 5px;" class="col-xs-12 col-sm-2 bloccodati"
       [typeLabel]="'date'" [labelInput]="'Data rinuncia'"
       [valueInput]="controparte.dataTermine"></div>
</div>
<div class="row">
     <div labelTextInput class="col-xs-12 col-sm-2 bloccodati"
     [typeLabel]="'text'" [labelInput]="'Tipo soggetto'"
     [valueInput]="controparte.flagAttore ? 'Attore' : 'Convenuto'"></div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label> <span
      class="longtext">{{ controparte.note }}</span>
    </p>
  </div>

</div>
